import TrouverSyndicatButton from "./TrouverSyndicatButton";

const PasDeSyndicat = () => {
  return (
    <>
      <div className="text-gray-700 mb-4">
        Vous n'êtes adhérent(e) d'aucun syndicat.
      </div>

      <TrouverSyndicatButton />
    </>
  );
};

export default PasDeSyndicat;
